export enum AppAddToICI {
  ADDTOICI = "addtoici",
}
